export var toolbarMenuRadioGroupWrapperStyles = {
  root: function root() {
    return {};
  }
};